module.exports = __webpack_public_path__ + "img/user-glyph-32.7fd61ad0.svg";